var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
export const Button = forwardRef((_a, ref) => {
    var _b;
    var { className = '', variant = 'default', children } = _a, props = __rest(_a, ["className", "variant", "children"]);
    const buttonClass = variant && variant !== 'default' ? `qmb-v2-button qmb-v2-button--${variant}` : 'qmb-v2-button';
    const combinedClassName = className ? `${buttonClass} ${className}` : buttonClass;
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading, react/button-has-type
    React.createElement("button", Object.assign({ ref: ref, className: combinedClassName, type: (_b = props.type) !== null && _b !== void 0 ? _b : 'button' }, props), children));
});
Button.displayName = 'Button';
